import { action, observable } from "mobx";
import NestStore from "./NestStore";
import GroupCustomersRepository from "../repository/GroupCustomersRepository";

class GroupCustomerStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable groupCustomers = [];

  /**
   * @type {GroupCustomersRepository}
   */
  groupCustomersRepository = null;

  rootStore = null;

  constructor() {
    super();

    this.groupCustomersRepository = new GroupCustomersRepository();
  }

  @action
  load() {
    return Promise.all([this.getCustomerGroup()]);
  }

  @action
  getCustomerGroup() {
    return this.groupCustomersRepository.fetchGroupCustomers().then(response => {
      this.processCustomers(response.data.customers);
    });
  }

  @action
  processCustomers(groupCustomers = []) {
    this.groupCustomers = [];
    groupCustomers.forEach(customer => {
      this.groupCustomers.push(customer);
    });
  }
}

export default GroupCustomerStore;
